import React from 'react'
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Swal from 'sweetalert2';
import Loading from '../../Components/Loading/LoadingCenterPage';
import LoadHospital from './LoadData/LoadHospital';
import NotifyDiscord from '../../Func/NotifyDiscord';

const Registration = () => {

    const dataHospital = LoadHospital()
    const [dataPositionJob, setDataPositionJob] = React.useState(null);
    const [dataExperience, setDataExperience] = React.useState(null);
    const [req_dataExperience, setreq_DataExperience] = React.useState(null);
    const [onLoad, setOnload] = React.useState(false);

    const handleChangePositionJob = (event, newValue) => {
        if (newValue) {
            setDataPositionJob(newValue.label); // ดึง value ของ item ที่เลือก
        }
    };
    const handleChangeExperience = (event, newValue) => {
        if (newValue) {
            setDataExperience(newValue.label); // ดึง value ของ item ที่เลือก
        }
    };
    const handleChangesetReq_DataExperience = (event, newValue) => {
        if (newValue) {
            setreq_DataExperience(newValue.hname); // ดึง value ของ item ที่เลือก
        }
    };

    const positionJob = [
        { label: "พยาบาลผู้เชี่ยวชาญไตเทียม" },
        { label: "พยาบาลไตเทียม(อบรมไตเทียม 6 เดือนแล้ว)" },
        { label: "พยาบาลวิชาชีพ(ยังไม่อบรมไตเทียม 6 เดือน)" },
        { label: "พนักงานผู้ช่วยพยาบาล" },
        { label: "ธุรการ" },
        { label: "แม่บ้าน" },
        { label: "พนักงานรับส่งผู้ป่วย" },
    ]
    const experience = [
        { label: "ไม่มีประสบการณ์" },
        { label: "น้อยกว่า 1 ปี" },
        { label: "1 ปี" },
        { label: "1 - 2 ปี" },
        { label: "3 ปีขึ้นไป" },
    ]

    const handleOnSubmit = (e) => {

        e.preventDefault()

        // form
        const form = document.getElementById('regis')
        const formData = new FormData(form);
        formData.append('action', 'create');

        if (dataHospital?.find(v => v.hname === req_dataExperience)?.hname === undefined) {
            Swal.fire({
                title: "ไม่พบสถานพยาบาลที่เลือก",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("name") === '') {
            Swal.fire({
                title: "กรุณาระบุชื่อ",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("nikname") === '') {
            Swal.fire({
                title: "กรุณาระบุชื่อเล่น",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("age") === '') {
            Swal.fire({
                title: "กรุณาระบุอายุ",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("positionjob") === '') {
            Swal.fire({
                title: "กรุณาระบุตำแหน่ง",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("experience") === '') {
            Swal.fire({
                title: "กรุณาระบุประสบการณ์ด้านไตเทียม",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("phone") === '') {
            Swal.fire({
                title: "กรุณาระบุเบอร์โทรติดต่อกลับ",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        if (formData.get("old_company") === '') {
            Swal.fire({
                title: "กรุณาระบุสถานที่ทำงานเดิม",
                icon: 'error',
                confirmButtonText: "ตกลง",
                allowOutsideClick: () => {
                    const popup = Swal.getPopup()
                    popup.classList.remove('swal2-show')
                    setTimeout(() => {
                        popup.classList.add('animate__animated', 'animate__headShake')
                    })
                    setTimeout(() => {
                        popup.classList.remove('animate__animated', 'animate__headShake')
                    }, 500)
                    return false
                },
            })

            return
        }

        const message = `
📥 **มีผู้สมัครรายใหม่**
====================
**ชื่อ-นามสกุล** : ${formData.get("name")}
**ชื่อเล่น** : ${formData.get("nikname")}
**อายุ** : ${formData.get("age")}
**ตำแหน่ง** : ${formData.get("positionjob")}
**ประสบการณ์** : ${formData.get("experience")}
**เบอร์โทร** : ${formData.get("phone")}
**สถานที่ทำงานเดิม** : ${formData.get("old_company")}
**สถานที่ต้องการทำงาน** : ${dataHospital?.find(v => v.hname === req_dataExperience)?.hname || '-'}
====================
`;

        Swal.fire({
            title: "ยืนยันบันทึก",
            icon: 'warning',
            showDenyButton: true,
            confirmButtonText: "ตกลง",
            denyButtonText: `ยกเลิก`,
            allowOutsideClick: () => {
                const popup = Swal.getPopup()
                popup.classList.remove('swal2-show')
                setTimeout(() => {
                    popup.classList.add('animate__animated', 'animate__headShake')
                })
                setTimeout(() => {
                    popup.classList.remove('animate__animated', 'animate__headShake')
                }, 500)
                return false
            },
        }).then((result) => {

            if (result.isConfirmed) {

                setOnload(true)

                fetch('https://script.google.com/macros/s/AKfycbxvOi1y2SpMqRssJhpa2dKgzd_k9reXEoNCtW0i086kSGQDq5nchndK7HioiJAo4xit3A/exec', {
                    method: 'POST',
                    body: formData
                })
                    .then(async (response) => {
                        await NotifyDiscord("1384743040626851952", "SOXRnqtMHWK7seHHkAaqsru7t5Hfq2q2a0TmSIDIng1XCyLYV_O5AvJcyvmh1fDJ13yo", message); // ✅ รอให้ส่ง Discord ก่อน

                        Swal.fire({
                            title: 'บันทึกข้อมูลสำเร็จ!!',
                            text: "เราจะติดต่อกลับภายใน 3 - 5 วันทำการ",
                            icon: 'success',
                            confirmButtonText: 'ตกลง',
                        }).then((result) => {
                            setOnload(false);
                            if (result.isConfirmed) {
                                window.location.replace("https://ratchaphruek-hemodialysis.web.app/");
                            }
                        });
                    })
                    .catch(error => {
                        console.error('Error!', error.message);
                        setOnload(false);
                        Swal.fire({
                            title: 'เกิดข้อผิดพลาด',
                            text: error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง',
                        });
                    });

            }

        });

    }

    return (

        <>

            {!!dataHospital ?
                <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
                    <div className="max-w-3xl mx-auto">
                        {/* Header Section */}
                        <div className="text-center mb-10">
                            <h1 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-4">
                                ลงทะเบียนสมัครงานไตเทียม
                            </h1>
                            <p className="text-lg text-slate-600">
                                ร่วมเป็นส่วนหนึ่งของเครือราชพฤกษ์ไตเทียม เพื่อการดูแลผู้ป่วยอย่างมืออาชีพ
                            </p>
                            <div className="mt-4 h-1.5 w-24 bg-blue-600 mx-auto rounded-full"></div>
                        </div>

                        {/* Form Card */}
                        <div className="bg-white shadow-xl rounded-2xl overflow-hidden">
                            <form
                                id="regis"
                                onSubmit={handleOnSubmit}
                                className="p-8 md:p-12 space-y-8"
                            >
                                {/* Section 1: ข้อมูลส่วนตัว */}
                                <div>
                                    <h2 className="text-xl font-semibold text-slate-800 mb-6 flex items-center">
                                        <span className="bg-blue-100 text-blue-600 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm">1</span>
                                        ข้อมูลส่วนตัว
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div className="space-y-1">
                                            <label className="text-sm font-medium text-slate-700">ชื่อ - นามสกุล *</label>
                                            <input
                                                required
                                                name="name"
                                                type="text"
                                                placeholder="กรุณากรอกชื่อ-นามสกุล"
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                            />
                                        </div>
                                        <div className="grid grid-cols-2 gap-4">
                                            <div className="space-y-1">
                                                <label className="text-sm font-medium text-slate-700">ชื่อเล่น *</label>
                                                <input
                                                    required
                                                    name="nikname"
                                                    type="text"
                                                    placeholder="ชื่อเล่น"
                                                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                />
                                            </div>
                                            <div className="space-y-1">
                                                <label className="text-sm font-medium text-slate-700">อายุ *</label>
                                                <input
                                                    required
                                                    name="age"
                                                    type="number"
                                                    placeholder="ปี"
                                                    className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                                />
                                            </div>
                                        </div>
                                        <div className="space-y-1 md:col-span-2">
                                            <label className="text-sm font-medium text-slate-700">เบอร์โทรติดต่อกลับ *</label>
                                            <input
                                                required
                                                name="phone"
                                                type="text"
                                                placeholder="08X-XXX-XXXX"
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <hr className="border-slate-100" />

                                {/* Section 2: ข้อมูลการทำงาน */}
                                <div>
                                    <h2 className="text-xl font-semibold text-slate-800 mb-6 flex items-center">
                                        <span className="bg-blue-100 text-blue-600 w-8 h-8 rounded-full flex items-center justify-center mr-3 text-sm">2</span>
                                        ข้อมูลการทำงานและตำแหน่งที่สนใจ
                                    </h2>
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

                                        {/* ตำแหน่งงาน */}
                                        <div className="space-y-1">
                                            <label className="text-sm font-medium text-slate-700">ตำแหน่งที่สมัคร *</label>
                                            <select
                                                required
                                                onChange={(e) => {
                                                    const selected = positionJob.find(item => item.label === e.target.value);
                                                    handleChangePositionJob(null, selected);
                                                }}
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none cursor-pointer"
                                            >
                                                <option value="">เลือกตำแหน่ง</option>
                                                {positionJob.map((item, index) => (
                                                    <option key={index} value={item.label}>{item.label}</option>
                                                ))}
                                            </select>
                                            <input type="hidden" name="positionjob" value={dataPositionJob || ''} />
                                        </div>

                                        {/* ประสบการณ์ */}
                                        <div className="space-y-1">
                                            <label className="text-sm font-medium text-slate-700">ประสบการณ์ด้านไตเทียม *</label>
                                            <select
                                                required
                                                onChange={(e) => {
                                                    const selected = experience.find(item => item.label === e.target.value);
                                                    handleChangeExperience(null, selected);
                                                }}
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none cursor-pointer"
                                            >
                                                <option value="">เลือกประสบการณ์</option>
                                                {experience.map((item, index) => (
                                                    <option key={index} value={item.label}>{item.label}</option>
                                                ))}
                                            </select>
                                            <input type="hidden" name="experience" value={dataExperience || ''} />
                                        </div>

                                        <div className="space-y-1 md:col-span-2">
                                            <label className="text-sm font-medium text-slate-700">สถานที่ทำงานเดิม *</label>
                                            <input
                                                required
                                                name="old_company"
                                                type="text"
                                                placeholder="ชื่อโรงพยาบาล หรือ คลินิกเดิม"
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                                            />
                                        </div>

                                        {/* สาขาที่ต้องการสมัคร */}
                                        <div className="space-y-1 md:col-span-2">
                                            <label className="text-sm font-medium text-slate-700">สาขาที่ต้องการปฏิบัติงาน *</label>
                                            <select
                                                required
                                                onChange={(e) => {
                                                    const selected = dataHospital.find(item => item.hname === e.target.value);
                                                    handleChangesetReq_DataExperience(null, selected);
                                                }}
                                                className="w-full px-4 py-3 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all appearance-none cursor-pointer"
                                            >
                                                <option value="">เลือกสาขา</option>
                                                {dataHospital.map((item, index) => (
                                                    <option key={index} value={item.hname}>
                                                        {item.hname} ({item.codeAddress?.split(", ")[2] || ''})
                                                    </option>
                                                ))}
                                            </select>
                                            <input type="hidden" name="req_company" value={req_dataExperience || ''} />
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="pt-6">
                                    {!onLoad ? (
                                        <button
                                            type="submit"
                                            className="w-full md:w-auto px-10 py-4 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl shadow-lg shadow-blue-200 transition-all transform hover:-translate-y-1 active:scale-95 flex items-center justify-center"
                                        >
                                            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                            </svg>
                                            บันทึกข้อมูลการสมัคร
                                        </button>
                                    ) : (
                                        <div className="flex justify-center py-4">
                                            <div className="flex space-x-2">
                                                <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce"></div>
                                                <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce [animation-delay:-.3s]"></div>
                                                <div className="w-3 h-3 bg-blue-600 rounded-full animate-bounce [animation-delay:-.5s]"></div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </form>
                        </div>

                        {/* Footer Info */}
                        <p className="mt-8 text-center text-slate-500 text-sm">
                            © {new Date().getFullYear()} Ratchaphruek Hemodialysis Group. All rights reserved.
                        </p>
                    </div>
                </div> : <Loading />
            }

        </>

    )
}

export default Registration
